import { useToast } from '@chakra-ui/react'
import { ChangeEvent, FormEvent, useState } from 'react'
import { post } from '../../../lib/http'
import val from '../../../lib/val'
import { storagePage } from '../storage'

export default function useSplitPayment(onDone: () => void) {
    const [isOpen, setOpen] = useState(false)
    const [isLoading, setLoading] = useState(false)
    const [helpers, setHelpers] = useState<{
        account?: string
        items?: string
    }>({})
    const toast = useToast()

    async function submitHandler(ev: FormEvent<HTMLFormElement>) {
        ev.preventDefault()
        const formElem = ev.target as typeof ev.target & {
            account: { value: string }
        }

        const v = val({
            account: formElem.account.value
        })

        v.account.isEmpty('Es requerido seleccionar una cuenta')

        // Validación adicional para items a dividir
        const hasItemsToSplit =
            storagePage.items_to_divide &&
            storagePage.items_to_divide.length > 0
        const hasValidQuantities = storagePage.items_to_divide?.some(
            item => item.quantity_to_divide && item.quantity_to_divide > 0
        )

        // Crear objeto de errores
        let errors: any = v.runtest()

        // Agregar validaciones de items
        if (!hasItemsToSplit) {
            errors = errors || {}
            errors.items = 'Debe seleccionar al menos un item para dividir'
        } else if (!hasValidQuantities) {
            errors = errors || {}
            errors.items = 'La cantidad a dividir debe ser mayor a cero'
        }

        // Validar que ningún item tenga cantidad 0 o vacía
        const invalidItems = storagePage.items_to_divide?.filter(
            item => !item.quantity_to_divide || item.quantity_to_divide <= 0
        )

        if (invalidItems && invalidItems.length > 0) {
            errors = errors || {}
            errors.items =
                'Todos los items deben tener una cantidad mayor a cero'
        }

        // Si hay errores, mostrarlos
        if (errors) {
            setHelpers(errors)

            // Mostrar toast con el error específico
            if (errors.items) {
                toast({
                    title: errors.items,
                    status: 'error',
                    position: 'top',
                    duration: 3000,
                    isClosable: true
                })
            }
            return
        }

        setLoading(true)

        // Filtrar solo items con cantidad válida antes de enviar
        const validItems = storagePage.items_to_divide.filter(
            item => item.quantity_to_divide && item.quantity_to_divide > 0
        )

        const { error } = await post<any>(
            `/api/account_orders/${storagePage.account_id}/add_items`,
            {
                account_settings: validItems.map(item => {
                    return {
                        order_item_id: item.id,
                        quantity: item.quantity_to_divide
                    }
                })
            }
        )

        if (error) {
            toast({
                title: error.message,
                status: 'error',
                position: 'top'
            })
            setOpen(false)
        } else {
            toast({
                title: 'Pago dividido exitosamente',
                status: 'success',
                position: 'top',
                isClosable: true
            })
            setOpen(false)
        }
        onDone()
        setLoading(false)
    }

    function changeHandler(
        ev: ChangeEvent<HTMLInputElement | HTMLSelectElement>
    ) {
        const name = ev.target.name as keyof typeof helpers
        if (helpers[name]) {
            setHelpers({
                ...helpers,
                [name]: ''
            })
        }
        storagePage.account_id = Number(ev.target.value)
    }

    return {
        isOpen,
        setOpen,
        submitHandler,
        isLoading,
        helpers,
        setHelpers,
        changeHandler
    }
}
